import { Controller } from "@hotwired/stimulus";

class OmnibusModalController extends Controller {
  static targets = ["modal"];

  toggleVisibility() {
    if (this.modalTarget.classList.contains("tw-hidden")) {
      this.modalTarget.classList.toggle("tw-hidden");
      requestAnimationFrame(() => {
        this.modalTarget.classList.toggle("tw-opacity-0");
      });
    } else {
      this.modalTarget.classList.toggle("tw-opacity-0");
      setTimeout(() => {
        this.modalTarget.classList.toggle("tw-hidden");
      }, 300);
    }
  }
}

Stimulus.register("omnibusModal", OmnibusModalController);
